<template>
    <LessonContent :title="lesson.title" :order="lesson.order">

    <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>

          <span class="font-black text-6xl">Responsibility</span>


          <div class="lesson-intro-image-wrapper">
            <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_1.svg"/>
          </div>


        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

          <p>
            Nothing works unless you do the work.
          </p>

            <div class="mt-4">
                Everything you get out of life is exclusively the <span class="font-semibold">result of actions you actually do or don't do.</span>
            </div>


            <div class="lg:w-1/3 w-2/3 mx-auto mt-8">
              <img src="@/assets/images/academy/aca_3.png"/>
            </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>


           <p>
             The first session is about <span class="font-semibold">taking responsibility</span>, because without it we would not get far.
           </p>

          <p class="mt-4">
            So starting today, you will begin a new daily routine that will take you <span class="font-italic">only 1 minute a day</span>.
          </p>

        
        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>


           <div class="lg:w-2/3 w-4/5 mx-auto">
              <img src="@/assets/images/academy/aca_4.png"/>
            </div>

        
        </LessonTabContent>
      </tab-content>

     



      <tab-content title="">
        <LessonTabContent>


           <div class="lg:w-2/3 w-4/5 mx-auto">
              <img src="@/assets/images/academy/aca_5.png"/>
            </div>
           <p class="">
             Throughout the whole <span class="font-semibold">improvee.io</span> experience, you will take care of this routine, do it every day and soon enough <span class="font-semibold">you will see the impact 1 minute can have on your life.</span>
           </p>


          

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

           <p class="text-3xl">
             The decision to start building ourselves is <span class="font-semibold">the most sincere act</span> we can do for ourselves.
           </p>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
       <div>

       <p class="">
         Pick any healthy routine according to your preferences, but if you don't mind, here are some suggestions:
       </p>

      <ul class="mt-4 text-base">
        <li>Drink a glass of water as soon as you wake up</li>
        <li>Sit with eyes closed and do nothing</li>
        <li>Evaluate your day in the evening</li>
        <li>Add leafy greens to your meal</li>
        <li>Plan your day in the morning</li>
        <li>Tidy up before going to bed</li>
        <li>Take a cold shower</li>
        <li>Fix your posture</li>
        <li>Breathe deeply</li>
        <li>Take vitamins</li>
        <li>Do a plank</li>
      </ul>

      </div>
        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

          <p class="text-3xl">
            Create a healthy 1 minute routine and do it everyday
          </p>

          <div class="justify-center mt-4">
            <vs-button  color="#5222D0" size="large" @click="redirectToActionBoard">create a routine</vs-button>
          </div>

          <p class="mt-8">
          </p>

        </LessonTabContent>
      </tab-content>

      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>

           <p class="">
             It would be embarrassing to stop doing something that takes you only 1 minute a day. 
           </p>

          <p class="mt-4">
             Don't overthink it; take it as brushing your teeth, <span class="font-semibold">you just do it</span>.
           </p>

           <div class="lg:w-1/3 w-3/5 mx-auto mt-12">
              <img src="@/assets/images/academy/aca_6.png"/>
            </div>

        </LessonTabContent>
      </tab-content>

    </form-wizard>

</LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    FormWizard,
    TabContent,
    LessonTabContent
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    redirectToActionBoard () {
      const routeData = this.$router.resolve({ name: 'planner', query: { initWithRoutineSidebarOpen: 'true'  }})
      window.open(routeData.href, '_blank')
    }
  },

}

</script>
